module.exports = __webpack_public_path__ + "static/media/Receipt.e0952d08.svg";